import {
    Box, chakra, Text
} from '@chakra-ui/react';

export const SchoolInfoWrapper = chakra(Box, {
    baseStyle: {
        fontFamily: 'Poppins, sans-serif',
        color: 'neutral.700',
        fontSize: '15px',
        fontWeight: 600,
        letterSpacing: '0.081px',
        width: 'auto',
        overflow: 'hidden'
    }
});

export const SchoolInfoText = chakra(Text, { baseStyle: { } });
